/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiCardsOnlyDto,
  ApiModuleDto,
  ApiModuleRequestDto,
  GetOrganisationExtendedModulesForOrganisationParams,
  ModuleDto,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiModuleController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-module-controller
   * @name RequestDemo
   * @request POST:/api/v1/modules/{apiModuleCode}/demo
   */
  requestDemo = (
    apiModuleCode:
      | 'ADVANCED_APPROVALS'
      | 'INVOICES'
      | 'REIMBURSEMENTS'
      | 'INSIGHTS'
      | 'SSO'
      | 'BUDGETS'
      | 'PREPAID_EXPENSES'
      | 'ADVANCED_INTEGRATIONS'
      | 'ACCOUNTING_AI_AUTOMATION'
      | 'POST_SPEND_APPROVALS'
      | 'DELEGATED_APPROVALS'
      | 'FIELD_BASED_APPROVALS'
      | 'PURCHASE_REQUESTS'
      | 'MANDATORY_FIELDS'
      | 'MULTIPLE_DIMENSIONS'
      | 'PAY_WITH_MOSS_PRICING'
      | 'CARDS'
      | 'ADVANCED_OCR'
      | 'UNKNOWN',
    params: RequestParams = {},
  ) =>
    this.http.request<ApiModuleRequestDto, any>({
      path: `/v1/modules/${apiModuleCode}/demo`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static requestDemoPath = '/v1/modules/${apiModuleCode}/demo'
  static requestDemoMethod = 'POST'
  /**
   * No description
   *
   * @tags api-module-controller
   * @name Activate
   * @request POST:/api/v1/modules/{apiModuleCode}/activate
   */
  activate = (
    apiModuleCode:
      | 'ADVANCED_APPROVALS'
      | 'INVOICES'
      | 'REIMBURSEMENTS'
      | 'INSIGHTS'
      | 'SSO'
      | 'BUDGETS'
      | 'PREPAID_EXPENSES'
      | 'ADVANCED_INTEGRATIONS'
      | 'ACCOUNTING_AI_AUTOMATION'
      | 'POST_SPEND_APPROVALS'
      | 'DELEGATED_APPROVALS'
      | 'FIELD_BASED_APPROVALS'
      | 'PURCHASE_REQUESTS'
      | 'MANDATORY_FIELDS'
      | 'MULTIPLE_DIMENSIONS'
      | 'PAY_WITH_MOSS_PRICING'
      | 'CARDS'
      | 'ADVANCED_OCR'
      | 'UNKNOWN',
    params: RequestParams = {},
  ) =>
    this.http.request<ApiModuleRequestDto, any>({
      path: `/v1/modules/${apiModuleCode}/activate`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static activatePath = '/v1/modules/${apiModuleCode}/activate'
  static activateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-module-controller
   * @name IsCardsOnly
   * @request POST:/api/v1/modules/is-cards-only
   */
  isCardsOnly = (params: RequestParams = {}) =>
    this.http.request<ApiCardsOnlyDto, any>({
      path: `/v1/modules/is-cards-only`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static isCardsOnlyPath = '/v1/modules/is-cards-only'
  static isCardsOnlyMethod = 'POST'
  /**
   * No description
   *
   * @tags api-module-controller
   * @name GetOrganisationModules
   * @request GET:/api/v1/modules
   */
  getOrganisationModules = (params: RequestParams = {}) =>
    this.http.request<ApiModuleDto[], any>({
      path: `/v1/modules`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationModulesPath = '/v1/modules'
  static getOrganisationModulesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-module-controller
   * @name GetOrganisationExtendedModulesForOrganisation
   * @request GET:/api/v1/modules/extended
   */
  getOrganisationExtendedModulesForOrganisation = (
    query: GetOrganisationExtendedModulesForOrganisationParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ModuleDto[], any>({
      path: `/v1/modules/extended`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getOrganisationExtendedModulesForOrganisationPath = '/v1/modules/extended'
  static getOrganisationExtendedModulesForOrganisationMethod = 'GET'
}
